import { useEffect, useRef } from 'react';
import BarToCircle from '../../assets/BarToCircle/BarToCircle';

interface Props {
  width?: string;
  zIndex?: string;
}

export const MainFallback = ({ width, zIndex }: Props) => {
  const statusRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const timer = setTimeout(() => statusRef.current?.focus(), 600);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      data-testid="loader-auth0ToRedux"
      style={{
        width: width ? (width as string) : '100vw',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: zIndex ? zIndex : '10000',
        backgroundColor: '#ffffff',
        position: 'relative',
        height: '100vh',
      }}
    >
      <div
        ref={statusRef}
        tabIndex={-1}
        role="status"
        aria-live="assertive"
        aria-atomic="true"
        aria-label="Loading"
        className="tw-sr-only"
      >
        Loading
      </div>
      <div style={{ width: '50vw' }}>
        <BarToCircle />
      </div>
    </div>
  );
};
